import { ScriptHTMLAttributes, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function Script(props: ScriptHTMLAttributes<HTMLScriptElement>) {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted) {
		return null;
	}

	return createPortal(<script {...props} />, document.body);
}
